import React from 'react'
import PropTypes from 'prop-types'

import IconClock from '../../../../../assets/icons/IconClock'
import useTranslations from '../../../../../i18n/useTranslations'

function ScheduleView({ schedule }) {
  const t = useTranslations()

  return (
    <div className="radio-extraInfoRow">
      <IconClock />
      <div className="radio-extraInfoDataWrapper">
        <p className="radio-extraInfoLabel font-label">{t('noun:schedule')}</p>
        {schedule?.map(schedule => (
          <p
            key={`${schedule.dayName}:${schedule.openingHours}`}
            className="radio-extraInfoData font-h4"
          >
            {schedule.dayName}: {schedule.openingHours}
          </p>
        ))}
      </div>
    </div>
  )
}

ScheduleView.propTypes = {
  schedule: PropTypes.arrayOf(
    PropTypes.shape({
      dayName: PropTypes.string,
      openingHours: PropTypes.string,
    }),
  ),
}

export default ScheduleView
